import { withAppCrashIfException } from 'epic';
import { cloneEssentialFormEpic } from 'epic/essential-form/clone';
import { essentialFormEnrichmentRequestedEpic } from 'epic/essential-form/enrich';
import { reloadQuoteEpic } from 'epic/essential-form/reload-quote';
import { essentialFormRollbackEpic } from 'epic/essential-form/rollback';
import { combineEpics } from 'redux-observable';
import { essentialScreenTabContentEpic } from 'state/workspaces/essential/tab-content';

import { essentialCancelQuoteEpic } from './cancel-quote';
import { fetchDefaultEssentialFormEpic } from './fetch-init-form';
import { fetchEssentialWorkspaceTabsEpic } from './fetch-workspace-tabs';
import { navigateToEssentialWorkspaceEpic } from './navigate-to-workspace';
import { quoteResultEpic } from './quote-result';
import { removeEssentialQuote } from './remove-quote';
import { essentialRequestQuoteEpic } from './request-quote';

export const essentialFormEpic = () =>
  combineEpics(
    withAppCrashIfException(navigateToEssentialWorkspaceEpic.name, navigateToEssentialWorkspaceEpic()),
    withAppCrashIfException(fetchEssentialWorkspaceTabsEpic.name, fetchEssentialWorkspaceTabsEpic()),
    withAppCrashIfException(fetchDefaultEssentialFormEpic.name, fetchDefaultEssentialFormEpic()),
    withAppCrashIfException(essentialScreenTabContentEpic.name, essentialScreenTabContentEpic()),
    withAppCrashIfException(essentialFormEnrichmentRequestedEpic.name, essentialFormEnrichmentRequestedEpic()),
    withAppCrashIfException(essentialRequestQuoteEpic.name, essentialRequestQuoteEpic()),
    withAppCrashIfException(quoteResultEpic.name, quoteResultEpic()),
    withAppCrashIfException(removeEssentialQuote.name, removeEssentialQuote()),
    withAppCrashIfException(essentialCancelQuoteEpic.name, essentialCancelQuoteEpic()),
    withAppCrashIfException(essentialFormRollbackEpic.name, essentialFormRollbackEpic()),
    withAppCrashIfException(cloneEssentialFormEpic.name, cloneEssentialFormEpic()),
    withAppCrashIfException(reloadQuoteEpic.name, reloadQuoteEpic()),
  );
